import React from "react";
import CustomCard from "../components/Card/Card";
import ImageScroller from "../components/ImageScroller/ImageScroller";
import StatsAndMilestones1 from "../components/StatsAndMilestones/StatsAndMilestones1";
import StatsAndMilestones2 from "../components/StatsAndMilestones/StatsAndMilestones2";

import projectImage1 from "../assets/imagescroller/about-banner2.jpg";
import projectImage2 from "../assets/imagescroller/E4BCE4D6-79BE-4913-AA2B-04292CDAAC30.jpeg";
import projectImage3 from "../assets/imagescroller/ga1.jpg";
import projectImage4 from "../assets/imagescroller/ga2.jpg";
import projectImage5 from "../assets/imagescroller/ga3.jpg";
import projectImage6 from "../assets/imagescroller/ga4.jpg";

export default function Home() {
  // Sample images - replace with actual project images
  const projectImages = [
    {
      src: projectImage1,
      alt: "Electrical Project",
      caption: "State-of-the-art electrical engineering solutions",
    },
    {
      src: projectImage2,
      alt: "Civil Engineering",
      caption: "Innovative infrastructure development projects",
    },
    {
      src: projectImage3,
      alt: "Infrastructure",
      caption: "Modern infrastructure solutions for growing communities",
    },
    {
      src: projectImage4,
      alt: "Industrial Project",
      caption: "Industrial electrical systems and automation",
    },
    {
      src: projectImage5,
      alt: "Residential Project",
      caption: "Residential electrical solutions with safety in mind",
    },
    {
      src: projectImage6,
      alt: "Commercial Project",
      caption: "Commercial electrical infrastructure and maintenance",
    },
  ];

  return (
    <>
      <ImageScroller
        images={projectImages}
        autoScrollInterval={5000} // 5 seconds between slides
      />
      <CustomCard
        title="Our Vision"
        desc="At <strong>Shilpaa Electricals</strong>, we aim to spark a new era of 
              progress across India by championing innovation, sustainability, 
              and safety in every project. Through advanced engineering solutions 
              and forward-thinking designs, we illuminate communities, energize 
              businesses, and empower socio-economic growth. Join us in brightening 
              India's future—one transformative project at a time."
        image={projectImage2}
      />
      <StatsAndMilestones1 />
      <CustomCard
        title="Our Services"
        desc="We on one of the leading Electrical Contractors (Internal & External) holding 'A' GRADE LICENSE exceeding 33 KV ( All voltages). We carry out installation of 33/11 Kv Substations and 220 – 400 Kv Line works, HT & LT works for various types of Industries, Software Companies, Apartments and Building. We also design and supply Electrical Power Distribution Panels, Process Control Panels, Power Factor Control Panels, AMF Panels, Integrated Power Control Panels and Cable Trays.
For the past 18 years we are in the field of Industrial Electrification and have established ourselves as a reliable and service oriented organization providing trouble free service to all our customers. We have provided services to different types of industries in the States of Andhra Pradesh, Telangana, Orissa, Kerala, Haryana, Uttar Pradesh, Jharkhand, Karnataka and Maharashtra. We are well equipped to handle any project anywhere in India."
        image={projectImage4}
        buttonTitle="Contact Us"
        buttonLink="/contact"
      />
      <StatsAndMilestones2 />
    </>
  );
}
